"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customRemovalCosts = exports.customRestorationCosts = exports.customOffsetsCosts = exports.edenPriceMatchTreesCosts = exports.customTreesCosts = void 0;
const projects_1 = require("../projects");
// Cost per tree
exports.customTreesCosts = {
    GBP: 0.6,
    EUR: 0.8,
    USD: 0.8,
    CAD: 1.1,
    AUD: 1.2,
};
// Eden Price Match Cost per tree
exports.edenPriceMatchTreesCosts = {
    GBP: 0.18,
    EUR: 0.22,
    USD: 0.26,
    CAD: 0.33,
    AUD: 0.35,
};
// Cost per tonne
exports.customOffsetsCosts = {
    GBP: 9.45,
    EUR: 11.2,
    USD: 12.5,
    CAD: 16.4,
    AUD: 18.9,
};
// Cost per M2 of habitat restoration.
exports.customRestorationCosts = {
    [projects_1.RestorationProjectType.Rainforest]: {
        GBP: 450,
        EUR: 540,
        USD: 600,
        CAD: 790,
        AUD: 900,
    },
    [projects_1.RestorationProjectType.Wetlands]: {
        GBP: 450,
        EUR: 540,
        USD: 600,
        CAD: 790,
        AUD: 900,
    },
    [projects_1.RestorationProjectType.Wildflowers]: {
        GBP: 450,
        EUR: 540,
        USD: 600,
        CAD: 790,
        AUD: 900,
    },
    [projects_1.RestorationProjectType.Wildlife]: {
        GBP: 450,
        EUR: 540,
        USD: 600,
        CAD: 790,
        AUD: 900,
    },
};
// Cost per tonne
exports.customRemovalCosts = {
    [projects_1.CarbonRemovalProjectType.AfforestationReforestationAndRevegetation]: {
        GBP: 30,
        EUR: 35.4,
        USD: 39.5,
        CAD: 52.1,
        AUD: 60,
    },
    [projects_1.CarbonRemovalProjectType.BlueCarbon]: {
        GBP: 50,
        EUR: 58.9,
        USD: 65.8,
        CAD: 86.7,
        AUD: 99.9,
    },
    [projects_1.CarbonRemovalProjectType.Biochar]: {
        GBP: 270,
        EUR: 318.1,
        USD: 355,
        CAD: 468.2,
        AUD: 539.3,
    },
    [projects_1.CarbonRemovalProjectType.DirectAirCapture]: {
        GBP: 1000,
        EUR: 1000,
        USD: 1200,
        CAD: 1500,
        AUD: 1590,
    },
};
//# sourceMappingURL=data:application/json;base64,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